<template>
    <div class="d-flex d-inline">
        <router-link :to="{name: 'online_contract_show', params: {hashid: row.id}}" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-eye"></i>
        </router-link>

        <div>
            <a v-if="row.status !== contractStatus.PENDING" @click="downloadSignedFile(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                <i class="fa fa-cloud-download-alt"></i>
            </a>
            <a v-else @click="downloadFile(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                <i class="fa fa-download"></i>
            </a>

        </div>
        <a v-if="row.status === contractStatus.PENDING" @click="deleteRow(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-trash"></i>
        </a>
    </div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import axios from "axios";
import {ApiUrl, onlineContractService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";
import {contractStatus} from "@/constants/onlineContract";
import toastr from "toastr";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        contractStatus() {
            return contractStatus
        },
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods : {
        downloadFile(row) {

            axios({
                url: ApiUrl.path(`online-contract/contract/download/${row.id}`),
                method: 'GET',
                params: {},
                responseType: 'blob',
            }).then(
                response => {
                    let fileName = row.id +'_' + row.user_full_name + '_' + row.start_at + '_'+row.end_at+'.pdf'; // Default filename

                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Use the extracted filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); // Clean up
                },
                error => {
                    this.toastr.error(i18n.t('reports.tax.failedMessage'))
                });
            },
            downloadSignedFile(row) {
            axios({
                url: ApiUrl.path(`online-contract/contract/download-signed/${row.id}`),
                method: 'GET',
                params: {},
                responseType: 'blob',
            }).then(
                response => {
                    let fileName = row.id +'_' + row.user_full_name + '_' + row.start_at + '_'+row.end_at+ '-signed' +'.pdf'; // Default filename

                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Use the extracted filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); // Clean up
                },
                error => {
                    this.toastr.error(i18n.t('reports.tax.failedMessage'))
                });
            },
        deleteRow(row) {
            if (confirm(i18n.t('online_contract.alerts.delete_contract'))) {
                onlineContractService.contractDelete(row.id)
                    .then(({data}) => {
                        this.toastr.success(data.message)
                        this.datatable.reload();
                    }).catch(({response}) => {
                        this.toastr.error(response.data.message)
                })
            }
        },
    },
})
</script>